import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { HelmetProvider } from 'react-helmet-async';

import { store, persistor } from 'store/index';

import Loader from 'components/Loader';

// Import global styles and tooltip overrides
import 'react-tooltip/dist/react-tooltip.css';
import './styles/tooltip-override.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

serviceWorker.unregister();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<Loader size={100} block />} persistor={persistor}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
